/// <reference path="../../../tools/typings/tsd.d.ts"/>
/// <reference path="./location-interfaces.ts"/>

namespace DealerwareWebServices {
    "use strict";

    import ILocationSettings = DealerwareWebServices.ILocationSettings;

    export class Location implements ILocation {

        private $q              : any;
        private $timeout        : any;
        private LocationModel   : any;

        public id                               : number = null;
        public address_id                       : number = null;
        public primary_name                     : string = null;
        public secondary_name                   : string = null;
        public phone_number                     : string = null;
        public email                            : string = null;
        public image_url                        : string = null;
        public line1                            : string = null;
        public line2                            : string = null;
        public city                             : string = null;
        public state                            : string = null;
        public zip                              : string = null;
        public latitude                         : string = null;
        public longitude                        : string = null;
        public showMap                          : boolean = undefined;

        public settings                         : ILocationSettings = null;

        private _defaults   : any = { };
        public dataUtils    : any;

        public agreedToTerms                    : boolean = false;


        constructor (public $injector : any) {
            this.$q             = this.$injector.get ('$q');
            this.$timeout       = this.$injector.get ('$timeout');
            this.LocationModel  = this.$injector.get ('LocationModel');
            this.dataUtils      = this.$injector.get ('DataUtils').getInstance();
        }

        private synchronizeCurrentWithDefaults (response: any) {

            var that = this;

            Object.keys (response.data).forEach ( (key: string) => {

                if ( (<any>that)[key] !== undefined
                     && ( typeof response.data[key] === 'string'
                          || typeof response.data[key] === 'number'
                          || key === 'settings'
                        )
                   ) {
                    (<any>that)[key] = angular.copy(response.data[key]);
                    that._defaults[key] = angular.copy(response.master[key]);
                }
            });
        }

        public fill (locationData : any) : any {

            this.synchronizeCurrentWithDefaults ({
                data    : locationData,
                master  : angular.copy (locationData)
            });

            return this;
        }

        public create (fakeResponse : any) : any {

            var address = angular.copy (fakeResponse.address_attributes);

            delete fakeResponse.address_attributes;

            // Fake up the response you'd get if you just got the location individually
            // via that endpoint.  Probably brittle, but then again this data format,
            // from Blayne's model code, hasn't changed in years.
            //
            var mungeLocationdData = this.LocationModel.mapResponseToLocationData ({
                data: {
                    location: fakeResponse,
                    addresses: [
                        address
                    ]
                }
            });

            return this.fill (mungeLocationdData);
        }

        public load (id? : number) : ng.IPromise<any> {

            var that = this;

            var deferred = this.$q.defer();

            this.LocationModel.getLocation ({
                promise: true,
                params: {
                    location_id         : id || this.id,
                    include_address     : true,
                    include_settings    : true
                }})
                .then ( (locationData : ng.IHttpPromiseCallbackArg<{ [key: string]: any }>) => {
                    locationData.data.name = locationData.data.primary_name;
                    window.localStorage.setItem('location', JSON.stringify(locationData.data));
                    window.localStorage.setItem('company_token', locationData.data.company_token);
                    that.fill (locationData.data);
                    deferred.resolve (that);
                })
                .catch ( (response: ng.IHttpPromiseCallbackArg<{}>) => {
                    deferred.reject (response);
                });

            return deferred.promise;
        }

        public loadSettings (id? : number) : ng.IPromise<any> {
            return this.loadLocationSection('getSettings', id);
        }

        public loadLocationSection (accessor: string, id? : number) : ng.IPromise<any> {

            var that = this;

            var deferred = this.$q.defer();

            this.LocationModel[accessor] ({
                promise: true,
                params: {
                    location_id : id || this.id
                }})
                .then ( (locationData : ng.IHttpPromiseCallbackArg<{}>) => {
                    this.synchronizeCurrentWithDefaults (locationData);
                    deferred.resolve (this);
                })
                .catch ( (response: any) => {

                    // Empty resource, 404, is (usually) not a real error.
                    //
                    if (response.apiResourceNotFound) {
                        deferred.resolve (this);
                    }
                    else {
                        deferred.reject (response);
                    }
                });

            return deferred.promise;
        }

        public add () : ng.IPromise<any> {
            return this.doSave();
        }

        public update (id? : number) : ng.IPromise<any> {
            return this.doSave (id);
        }

        public save (id? : number) : ng.IPromise<any> {

            if (id || this.id) {
                return this.update (id);
            }
            else {
                return this.add ();
            }
        }

        public doSave (id? : number) : ng.IPromise<any> {

            var that = this;

            var deferred = this.$q.defer();

            var saveMethod = id || this.id ? 'update' : 'create';

            var params : any = {
                include_address     : true
            };
            if (this.id) {
                params.location_id = id || this.id;
            }

            this.LocationModel[saveMethod] ({
                promise : true,
                data    : this,
                params  : params
            })
                .then( (locationData : any) => {
                    that.synchronizeCurrentWithDefaults (locationData);
                    deferred.resolve(that);
                })
                .catch( (response: any) => {
                    deferred.reject(response);
                });

            return deferred.promise;
        }

        public saveSettings () : ng.IPromise<any> {
            return this.saveLocationSection('Settings', this.settings.id);
        }

        public saveLocationSection (locationObjectType: string, id? : number) : ng.IPromise<any> {

            var that = this;

            var deferred = this.$q.defer();

            var saveMethod = (id ? 'update' : 'create') + locationObjectType;

            this.LocationModel[saveMethod] ({
                promise : true,
                data    : this,
                params  : {
                    location_id: this.id
                }
            })
                .then( (locationData : any) => {
                    that.synchronizeCurrentWithDefaults (locationData);
                    deferred.resolve(that);
                })
                .catch( (response: any) => {
                    deferred.reject(response);
                });

            return deferred.promise;
        }

        public clear () : void {
            this.id =   null;
        }

        public toSummaryString () : string {

            var summaryLines : string[] = [ ];

            if (! this.dataUtils.isBlank(this.primary_name)) {
                summaryLines.push(this.primary_name);
            }

            if (! this.dataUtils.isBlank(this.phone_number)) {
                summaryLines.push(this.phone_number)
            }

            return summaryLines.join('<br />');
        }

        // New location returns true, modified location returns false
        // if field values moved off of defaults.
        //
        public isLocationUnchanged () : boolean {

            var that = this;

            var isUnchangedResult = Object
                .keys (this._defaults)
                .every ( ( key: string ) => {
                    return key === 'settings'
                        || (<any>that)[key] === that._defaults[key];
                });

            return isUnchangedResult;
        }

        // As above except new location returns false;
        //
        public isLocationExistingOrUnchanged () : boolean {
            return (this.id && this.isLocationUnchanged());
        }

        public areSettingsUnchanged () : boolean {

            var that = this;

            if (! this._defaults.settings) {
                return true;
            }

            var isUnchangedResult = Object
                .keys (this._defaults.settings)
                .every ( ( key: string ) => {
                    return (<any>that.settings)[key] === that._defaults.settings[key];
                });

            return isUnchangedResult;
        }

        public areSettingsExistingOrUnchanged () : boolean {
            return (this.id && this.areSettingsUnchanged());
        }

        public isAllDataExistingOrUnchanged () : boolean {
            return ( this.isLocationExistingOrUnchanged());
        }

        public isDms() : boolean {
            return this.settings && !this.dataUtils.isBlank(this.settings.dms_provider);
        }
    }

    getDealerwareWebServicesModule()
        .service ('Location', Location);



    export class CurrentLocation implements ICurrentLocation {
        public static $inject: string[] = [
            '$q',
            'LocationModel',
            'CurrentUser',
            'DataUtils'
        ];

        private _location: any;
        private dataUtils: any;

        constructor(public $q: any,
                    public LocationModel: any,
                    public CurrentUser: any,
                    public DataUtils: any) {
            this.dataUtils = this.DataUtils.getInstance();
        }

        public get() : ng.IPromise<any> {
            var locationId = this.CurrentUser.getLocation().id,
                _deferred = this.$q.defer(),
                _self = this;

            if (!locationId) {
                _deferred.reject({ data: { message: 'Please select a location' }});
            } else if (this._location && locationId == this._location.id) {
                _deferred.resolve(this._location);
            } else {
                this.LocationModel.show({
                    promise: true,
                    params: {
                        id: locationId,
                        include_address: true,
                        include_settings: true
                    }}
                ).then((locationData : ng.IHttpPromiseCallbackArg<{}>) => {
                    _self._location = locationData;
                    _deferred.resolve(locationData);
                }).catch((response: ng.IHttpPromiseCallbackArg<{}>) => {
                    _deferred.reject (response);
                });
            }

            return _deferred.promise;
        }

        public isDms() : boolean {

            return (
                   this._location
                && this._location.data
                && this._location.data.settings
                && ! this.dataUtils.isBlank(this._location.data.settings.dms_provider)
            ) ? true : false;
        }
    }

    getDealerwareWebServicesModule()
        .service('CurrentLocation', CurrentLocation);



    export class LocationFactory implements ILocationFactory {

        public static $inject: string[] = [ '$q', '$injector' ];

        constructor (
            private $q: any,
            private $injector: any
        ) { }

        public getInstance () : Location {
            return new Location (this.$injector);
        }
    }

    getDealerwareWebServicesModule ()
        .service('LocationFactory', LocationFactory);
}
